import * as api from '../api';

export const fetchSiteOperationTypes = (args) => {
  return api.callGet('/manager/site-operation-type', args);
};

export const fetchSiteModelYears = (args) => {
  return api.callGet('/manager/site-model-year', args);
};
